export default class BaseConnector {
  setStatusBarColor (color) {}
  setNavigationBarColor (color) {}
  setModalOpened (modalOpened) {}
  setModalClosed () {}
  onVisitCart (currentFullRoute) {}
  onUpdateCart (cartFullRoute) {}
  awayFromCart (currentFullRoute) {}
  onClearCart (currentFullRoute) {}
  getVisitorDetails (tokenValidation) {}
}
